module.exports = __webpack_public_path__ + "img/sample-dentist.69b2010e.webp";